import script from "./languageButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./languageButton.vue?vue&type=script&setup=true&lang=ts"

import "./languageButton.vue?vue&type=style&index=0&id=5333d558&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5333d558"]])

export default __exports__